import React from 'react';
import './option-list-modal.scss';

export const OptionListModal = ({ children, onClose = () => {}, positionY = 'bottom', positionX = 'right', backdropStyle = '' }) =>
  <div onClick={onClose} className='option-settings-wrapper'>
    <div className={`option-list-modal ${positionY} ${positionX} ${backdropStyle}`}>
      {children}
    </div>
  </div>